export const BLOG_TYPES_CONSTS = {
    GET_BLOG_TYPES: "GET_BLOG_TYPES",
    CREATE_BLOG_TYPES: "CREATE_BLOG_TYPES",
    UPDATE_BLOG_TYPES: "UPDATE_BLOG_TYPES",
    DELETE_BLOG_TYPES_BY_ID: "DELETE_BLOG_TYPES_BY_ID",
};
